import { render, staticRenderFns } from "./IndustryCreateUpdate.vue?vue&type=template&id=d1c69636&scoped=true&"
import script from "./IndustryCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./IndustryCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./IndustryCreateUpdate.vue?vue&type=style&index=0&id=d1c69636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c69636",
  null
  
)

export default component.exports